var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup536Red(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(432.035 -208.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M-404.412,208.592c6.407,0,12.814-.017,19.222.01a5.522,5.522,0,0,1,5,3.344,2.483,2.483,0,0,1-.6,3.382q-6,5.2-12,10.4-5.017,4.348-10.033,8.7c-1.293,1.121-1.911,1.12-3.215-.01l-22.032-19.1a2.451,2.451,0,0,1-.609-3.32,5.533,5.533,0,0,1,5.039-3.39C-417.227,208.574-410.819,208.592-404.412,208.592Zm-19.738,4.475,19.735,17.189,19.731-17.189Z",
    transform: "translate(-2.615)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M-407.032,331.228q-9.494,0-18.987,0c-3.515,0-6.012-2.882-6.014-6.937q0-8.713,0-17.426a2.17,2.17,0,0,1,1.655-2.284,1.96,1.96,0,0,1,2.123,1.686,4.263,4.263,0,0,1,.059.894q0,8.539,0,17.079c0,1.685.755,2.55,2.226,2.55h37.854c1.5,0,2.232-.858,2.232-2.613q0-8.644,0-17.287a2.164,2.164,0,0,1,1.694-2.312,1.958,1.958,0,0,1,2.078,1.667,3.391,3.391,0,0,1,.065.754q.005,8.748,0,17.5c-.005,3.783-2.553,6.729-5.825,6.733Q-397.448,331.239-407.032,331.228Z",
    transform: "translate(0 -82.644)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup536Red);
export default __webpack_public_path__ + "static/media/Group 536 red.9fc5612a66522a7fbd36f46a1bf00659.svg";
export { ForwardRef as ReactComponent };